import ResetPasswordForm from 'components/ResetPasswordForm';

export default function ResetPassword() {
  return <ResetPasswordForm />;
}
